export enum RecordTypes {
  INTERNSHIP_GROUP = 'INTERNSHIP_GROUP',
}
